module.exports = __webpack_public_path__ + "static/media/30OIOS4.50836edb.jpg";